import { AxiosResponse } from 'axios';
import agent from 'src/api_v2/base';
import { FetchARProjectAuditListParams, ARProjectAuditListPageResult } from './types';
import moment from 'moment';
class ARProjectAuditApi {
  async fetchARProjectAuditList(params: FetchARProjectAuditListParams) {
    try {
      const response: AxiosResponse = await agent.get(
        `/ar-projects-audit?${params.toString()}`
      );

      if (response.status === 200) {
        return response.data as ARProjectAuditListPageResult;
      }

      return []
    } catch (err) {
      throw new Error(err);
    }
  }

  async exportFile(params: FetchARProjectAuditListParams): Promise<any> {
    try {
      const response: AxiosResponse = await agent.post(
        `/ar-projects-audit/export/csv?${params.toString()}`,
        {
          responseType: 'blob'
        }
      );

      if (response.status === 201) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.setAttribute(
          'download',
          `ar-project-${moment().format('YYYY-MM-DD, HH-mm')}.csv`
        );
        link.href = url;
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);

        return true;
      }
      return false;
    } catch (err) {
      throw err;
    }
  }

}

const arProjectAuditListApi = new ARProjectAuditApi();
export default arProjectAuditListApi;
